export default {
  saks: {
    en: 'Saks Select',
  },
}
